// extracted by mini-css-extract-plugin
module.exports = {"container":"Detail_container__iTcNk","panel":"Detail_panel__1T4Ct"};